import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { PropsWithChildren } from "react";

import { PRIMARY_NAVIGATION_HEADER_ROW_HEIGHT } from "../../../../constants";
import { NavigationHeaderRow } from "../../../NavigationHeader/NavigationHeaderRow";
import { PrimaryNavigationToggle } from "./PrimaryNavigationToggle";

const HeaderRow = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "start",
  borderBottom: `1px solid ${theme.palette.secondary[6]}`,
  width: "100%",
  height: PRIMARY_NAVIGATION_HEADER_ROW_HEIGHT,
  flexShrink: 0,
  flexGrow: 0,
  flexWrap: "nowrap",
}));

interface PrimaryNavigationHeaderRowProps extends PropsWithChildren {
  hideToggle?: boolean;
}

export const PrimaryNavigationHeaderRow = (
  props: PrimaryNavigationHeaderRowProps,
) => {
  const { hideToggle, children } = props;
  return (
    <HeaderRow>
      {!hideToggle && <PrimaryNavigationToggle />}
      <NavigationHeaderRow
        sx={{
          flexShrink: 1,
          flexGrow: 1,
          borderBottom: "none",
        }}
      >
        {children}
      </NavigationHeaderRow>
    </HeaderRow>
  );
};
